
















































import { Component, Vue } from 'vue-property-decorator'
import ContactForm from "@/components/ContactForm.vue"
import Arrows from '@/components/Arrows.vue'
import calendly from '@/util/calendly'

type Option = {
  name: string
  title: string
  text: string
  hideIfSignedIn: boolean
  button: {
    text: string
    color: string
    action?: Function
  }
  dialog: boolean
}

function openCalendly() {
  calendly.showPopupWidget('https://calendly.com/d/cps-z6n-m4m/worxstr-consultation?hide_event_type_details=0&hide_gdpr_banner=1&primary_color=2e6aef')
}

@Component({
  metaInfo: {
    title: 'Contact us'
  },
  components: {
    ContactForm,
    Arrows
  },
})
export default class Contact extends Vue {

  mounted() {
    if (this.$route.params.option) {
      this.selectOption(this.helpOptions.find(option => option.name == this.$route.params.option))
    }
  }

  get me() {
    return this.$store.getters.me
  }

  selectOption(option: any) {
    if (option.button.action) {
      option.button.action()
    }
    else {
      this.chosenOption = option.name
    }
  }

  chosenOption: 'support' | 'sales' | string | null = null

  helpOptions: Option[] = [
    {
      name: 'demo',
      title: 'Schedule a demo',
      text: 'Want to learn more about our platform? Schedule a demo with one of our managers to learn more about Worxstr and how it can help you manage your team.',
      hideIfSignedIn: true,
      button: {
        text: 'Find a time',
        color: 'primary',
        action: openCalendly
      },
      dialog: false,
    },
    {
      name: 'support',
      title: "Help and support",
      text: "Having technical trouble? Contact our support team and we will get back to you soon.",
      hideIfSignedIn: false,
      button: {
        text: "Contact support",
        color: "accent",
      },
      dialog: false,
    },
    {
      name: 'sales',
      title: "Sales and pricing",
      text: "Need help deciding if Worxstr is right for you? Contact our sales team and we can help you choose.",
      hideIfSignedIn: true,
      button: {
        text: "Contact sales",
        color: "primary",
      },
      dialog: false,
    },
  ]
}
